import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Auth
import { AuthProvider } from "./contexts/AuthContext";

// Components
import { Header } from "./components/Header";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public Pages
import { Home } from "./pages/public/Home";
import { Projects } from "./pages/public/Projects";
import { About } from "./pages/public/About";
import { ProjectDetail } from "./pages/public/ProjectDetail";
import { ArtworkPage } from "./pages/public/SoftwareOffering";
import { ArtworkDetailPage } from "./pages/public/SoftwareOfferingsDetailPage";
import { Feedback } from "./pages/public/Feedback";
import { PhotoGallery } from "./pages/public/PhotoGallery";
import { PhotoGalleryDetail } from "./pages/public/PhotoGalaryDetail";
import { Contact } from "./pages/public/Contact";

// Admin Pages
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AddProjectPage } from "./pages/admin/AddProjectPage";
import { AddArtworkPage } from "./pages/admin/AddSoftwareOfferingPage";
import { DashboardPage } from "./pages/admin/DashboardPage";
import { ProjectsListPage } from "./pages/admin/ProjectsListPage";
import { EditProjectPage } from "./pages/admin/EditProjectPage";
import { ArtworksListPage } from "./pages/admin/SoftwareOfferingListPage";
import { EditArtworkPage } from "./pages/admin/EditSoftwareOfferingPage";
import { EditSettingsPage } from "./pages/admin/EditSettingsPage";
import { ContactsPage } from "./pages/admin/ContactsPage";
import { FeedbackPage } from "./pages/admin/FeedbackPage";
import { AdminFaqs } from "./pages/admin/AdminFaqs";

// Photo Gallery Admin Pages
import { AddPhotoGalleryPage } from "./pages/admin/AddPhotoGalleryPage";
import { EditPhotoGalleryPage } from "./pages/admin/EditPhotoGallery";
import { PhotoGalleryListPage } from "./pages/admin/PhotoGalleryListPage";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Header />
        <Routes>
          {/* === Public Routes === */}
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/artworks" element={<ArtworkPage />} />
          <Route path="/artworks/:id" element={<ArtworkDetailPage />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/photogallery" element={<PhotoGallery />} />
          <Route path="/photogallery/:id" element={<PhotoGalleryDetail />} />
          <Route path="/contact" element={<Contact />} />

          {/* === Admin Public Route === */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* === Protected Admin Routes === */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" index element={<DashboardPage />} />

              {/* Projects */}
              <Route path="/admin/projects/new" element={<AddProjectPage />} />
              <Route path="/admin/projects" element={<ProjectsListPage />} />
              <Route
                path="/admin/projects/edit/:id"
                element={<EditProjectPage />}
              />

              {/* Artworks */}
              <Route path="/admin/artworks/new" element={<AddArtworkPage />} />
              <Route path="/admin/artworks" element={<ArtworksListPage />} />
              <Route
                path="/admin/artworks/edit/:id"
                element={<EditArtworkPage />}
              />

              {/* Photo Gallery */}
              <Route
                path="/admin/photos/new"
                element={<AddPhotoGalleryPage />}
              />
              <Route path="/admin/photos" element={<PhotoGalleryListPage />} />
              <Route
                path="/admin/photos/edit/:id"
                element={<EditPhotoGalleryPage />}
              />
              {/* Contacts */}
              <Route path="/admin/contacts" element={<ContactsPage />} />
              {/* Feedback */}
              <Route path="/admin/feedback" element={<FeedbackPage />} />
              {/* FAQs */}
              <Route path="/admin/faqs" element={<AdminFaqs />} />
              {/* Settings */}
              <Route path="/admin/settings" element={<EditSettingsPage />} />
            </Route>
          </Route>

          {/* Optional: 404 fallback */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
